export default __webpack_public_path__ + "static/media/20.0b90ea59.jpg";